export const C = {
    bg: "#F5F6FA", surface: "#FFFFFF", card: "#FFFFFF", cardBorder: "#E2E5EC",
    hover: "#F0F1F5", accent: "#D23A3B", accentSoft: "rgba(210,58,59,0.08)",
    green: "#16A34A", greenSoft: "rgba(22,163,74,0.08)",
    red: "#DC2626", redSoft: "rgba(220,38,38,0.08)",
    orange: "#D97706", orangeSoft: "rgba(217,119,6,0.08)",
    purple: "#7C3AED", purpleSoft: "rgba(124,58,237,0.08)",
    blue: "#0891B2", blueSoft: "rgba(8,145,178,0.08)",
    t1: "#1A1D2E", t2: "#475569", t3: "#64748B", divider: "#E8EAF0",
    shadow: "0 1px 3px rgba(0,0,0,0.06)",
    font: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};

